// removed by extract-text-webpack-plugin
module.exports = {"bookNow":"ls_hc","button":"ls_bp","title":"ls_n","subtitle":"ls_bo","arrow":"ls_g0"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventHeader/BookNow/styles.module.css
// module id = 200
// module chunks = 27